import SpriteSymbol from "../../../.yarn/cache/svg-baker-runtime-npm-1.4.3-83b301e572-cae068de31.zip/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../.yarn/cache/svg-sprite-loader-npm-4.2.1-14e35b6f3a-33d9521566.zip/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_general_arrow_bottom",
  "use": "icon-icon_general_arrow_bottom-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 48\" overflow=\"visible\" id=\"icon-icon_general_arrow_bottom\">\n<g>\n\t<polygon points=\"24,35.5 6.1999998,17.7999992 9.8000002,14.1999998 24,28.5 38.2000008,14.1999998\n\t\t41.7999992,17.7999992 \t\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol